import React, { useState, useRef } from "react";
import { Modal, Button, Flex, Image } from "antd";
import {
    CameraOutlined,
    CheckOutlined,
    CloseOutlined,
    RedoOutlined,
} from "@ant-design/icons";
import Webcam from "react-webcam";

function CameraCaptureModal({ open, onClose, onCaptureComplete }) {
    const webcamRef = useRef(null);
    const [capturedImage, setCapturedImage] = useState(null);
    const [webcamKey, setWebcamKey] = useState(0);

    const closeAndCleanup = () => {
        if (webcamRef.current?.stream) {
            webcamRef.current.stream
                .getTracks()
                .forEach((track) => track.stop());
        }
        setCapturedImage(null);
        onClose();
    };

    const capturePhoto = () => {
        if (webcamRef.current) {
            const imageSrc = webcamRef.current.getScreenshot();
            setCapturedImage(imageSrc);
        }
    };

    const retakePhoto = () => {
        setCapturedImage(null);
        setWebcamKey((prev) => prev + 1);
    };

    const handleProceed = () => {
        if (!capturedImage) return;
        fetch(capturedImage)
            .then((res) => res.blob())
            .then((blob) => {
                const file = new File([blob], "captured-image.jpeg", {
                    type: "image/jpeg",
                });
                onCaptureComplete(file);
                closeAndCleanup();
            })
            .catch((err) =>
                console.error("Error converting captured image:", err),
            );
    };

    return (
        <Modal
            open={open}
            title="Take a Photo"
            onCancel={closeAndCleanup}
            footer={
                <Flex
                    justify="center"
                    gap="small"
                    style={{
                        width: "100%",
                        height: 80,
                        alignItems: "center",
                        padding: "0 24px",
                    }}
                >
                    {capturedImage ? (
                        <>
                            <Button
                                type="default"
                                size="large"
                                onClick={retakePhoto}
                                icon={<RedoOutlined style={{ fontSize: 20 }} />}
                            />
                            <Button
                                type="primary"
                                size="large"
                                onClick={handleProceed}
                                icon={
                                    <CheckOutlined style={{ fontSize: 20 }} />
                                }
                            >
                                Proceed
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                type="default"
                                size="large"
                                onClick={closeAndCleanup}
                                icon={
                                    <CloseOutlined style={{ fontSize: 20 }} />
                                }
                            />
                            <Button
                                type="primary"
                                size="large"
                                onClick={capturePhoto}
                                icon={
                                    <CameraOutlined style={{ fontSize: 20 }} />
                                }
                            >
                                Capture
                            </Button>
                        </>
                    )}
                </Flex>
            }
            centered
            width={700}
            maskClosable={false}
            destroyOnHidden
        >
            {capturedImage ? (
                <Image
                    src={capturedImage}
                    alt="Captured"
                    style={{
                        width: "100%",
                        borderRadius: 8,
                        maxHeight: 450,
                        objectFit: "contain",
                    }}
                    preview={false}
                />
            ) : (
                open && (
                    <Flex
                        justify="center"
                        align="center"
                        style={{
                            position: "relative",
                            width: "100%",
                            height: 450,
                            backgroundColor: "#000",
                            borderRadius: 8,
                            overflow: "hidden",
                        }}
                    >
                        <Webcam
                            key={webcamKey}
                            audio={false}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            width="100%"
                            height="100%"
                            videoConstraints={{ facingMode: "user" }}
                            style={{ borderRadius: 8, objectFit: "cover" }}
                        />
                    </Flex>
                )
            )}
        </Modal>
    );
}

export default CameraCaptureModal;
